export default {
  "EXP_ROAD_2030S_SSP3_VALUE_SING_GLOBAL": "Road(km)",
  "EXP_RICE_HT_2030S_RCP26_VALUE_MME_GLOBAL": "Area Exposure(#10^2# ha)",
  "EXP_MAIZE_HT_2050S_RCP26_VALUE_MME_GLOBAL": "Area Exposure(#10^2# ha)",
  "EXP_POP_RAIN_2030S_RCP85_CHANGE_MME_GLOBAL": "POP_RAIN_CHANGE (106person-mm)",
  "EXP_POP_RAIN_2050S_RCP45_VALUE_MME_GLOBAL": "Population exposure(106person-mm)",
  "EXP_MAIZE_HT_2000S_S0_VALUE_SING_GLOBAL": "Area Exposure(#10^2# ha)",
  "EXP_MAIZE_HT_2030S_RCP26_VALUE_MME_GLOBAL": "Area Exposure(#10^2# ha)",
  "EXP_RICE_HT_2030S_RCP85_VALUE_MME_GLOBAL": "Area Exposure(#10^2# ha)",
  "EXP_RICE_HT_2000S_S0_VALUE_MME_GLOBAL": "Area Exposure(#10^2# ha)",
  "EXP_IND_VALUE_2050S_SSP2_VALUE_SING_GLOBAL": "Industrial value added(#10^6# USD)",
  "EXP_MAIZE_HT_2030S_RCP85_VALUE_MME_GLOBAL": "Area Exposure(#10^2# ha)",
  "EXP_POP_HT_2030S_RCP85_VALUE_MME_GLOBAL": "Population exposure(#10^6# person-day)",
  "EXP_POP_RAIN_2050S_RCP45_CHANGE_MME_GLOBAL": "POP_RAIN_CHANGE (106person-mm)",
  "EXP_POP_RAIN_2050S_RCP26_CHANGE_MME_GLOBAL": "POP_RAIN_CHANGE (106person-mm)",
  "EXP_RICE_HT_2050S_RCP26_VALUE_MME_GLOBAL": "Area Exposure(#10^2# ha)",
  "EXP_MAIZE_2000S_S0_VALUE_SING_GLOBAL": "Maize Area(#10^2# ha)",
  "EXP_POP_RAIN_2050S_RCP26_CHANGE_MMS_GLOBAL": "SD _RAIN _CHANGE",
  "EXP_POP_RAIN_2030S_RCP45_VALUE_MME_GLOBAL": "Population exposure(106person-mm)",
  "EXP_ROAD_2050S_SSP2_VALUE_SING_GLOBAL": "Road(km)",
  "EXP_POP_HT_2050S_RCP26_VALUE_MME_GLOBAL": "Population exposure(#10^6# person-day)",
  "EXP_POP_RAIN_2050S_RCP85_VALUE_MME_GLOBAL": "Population exposure(106person-mm)",
  "EXP_IND_VALUE_2030S_SSP1_VALUE_SING_GLOBAL": "Industrial value added(#10^6# USD)",
  "EXP_POP_RAIN_2030S_RCP85_VALUE_MME_GLOBAL": "Population exposure(106person-mm)",
  "EXP_POP_RAIN_2030S_RCP85_CHANGE_MMS_GLOBAL": "SD _RAIN _CHANGE",
  "EXP_IND_VALUE_2030S_SSP3_VALUE_SING_GLOBAL": "Industrial value added(#10^6# USD)",
  "EXP_POP_RAIN_2030S_RCP26_CHANGE_MME_GLOBAL": "POP_RAIN_CHANGE (106person-mm)",
  "EXP_POP_HT_2030S_RCP26_VALUE_MME_GLOBAL": "Population exposure(#10^6# person-day)",
  "EXP_GDP_2050S_SSP2_VALUE_SING_GLOBAL": "GDP(#10^6# US$)",
  "EXP_WHEAT_2050S_RCP45_VALUE_MME_GLOBAL": "Wheat Cultivation Area(#10^2# ha)",
  "EXP_RICE_HT_2050S_RCP45_VALUE_MME_GLOBAL": "Area Exposure(#10^2# ha)",
  "EXP_POP_RAIN_2030S_RCP45_CHANGE_MME_GLOBAL": "POP_RAIN_CHANGE (106person-mm)",
  "EXP_POP_RAIN_2030S_RCP45_CHANGE_MMS_GLOBAL": "SD _RAIN _CHANGE",
  "EXP_MAIZE_2050S_RCP45_VALUE_MME_GLOBAL": "Maize Area(#10^2# ha)",
  "EXP_GDP_2030S_SSP3_VALUE_SING_GLOBAL": "GDP(#10^6# US$)",
  "EXP_POP_RAIN_2030S_RCP26_CHANGE_MMS_GLOBAL": "SD _RAIN _CHANGE",
  "EXP_ROAD_2050S_SSP3_VALUE_SING_GLOBAL": "Road(km)",
  "EXP_POP_2030S_SSP1_VALUE_SING_GLOBAL": "Population(person)",
  "EXP_RICE_2030S_RCP85_VALUE_MME_GLOBAL": "Rice Area(#10^2# ha)",
  "EXP_IND_VALUE_2050S_SSP1_VALUE_SING_GLOBAL": "Industrial value added(#10^6# USD)",
  "EXP_POP_2000S_S0_VALUE_SING_GLOBAL": "Population(person)",
  "EXP_GDP_2050S_SSP3_VALUE_SING_GLOBAL": "GDP(#10^6# US$)",
  "EXP_POP_RAIN_2050S_RCP85_VALUE_MMS_GLOBAL": "SD_RAIN",
  "EXP_MAIZE_2030S_RCP45_VALUE_MME_GLOBAL": "Maize Area(#10^2# ha)",
  "EXP_WHEAT_2030S_RCP45_VALUE_MME_GLOBAL": "Wheat Cultivation Area(#10^2# ha)",
  "EXP_IND_VALUE_2030S_SSP2_VALUE_SING_GLOBAL": "Industrial value added(#10^6# USD)",
  "EXP_POP_HT_2050S_RCP45_VALUE_MME_GLOBAL": "Population exposure(#10^6# person-day)",
  "EXP_POP_2050S_SSP1_VALUE_SING_GLOBAL": "Population(person)",
  "EXP_RICE_2050S_RCP26_VALUE_MME_GLOBAL": "Rice Area(#10^2# ha)",
  "EXP_WHEAT_2050S_RCP26_VALUE_MME_GLOBAL": "Wheat Cultivation Area(#10^2# ha)",
  "EXP_MAIZE_2030S_RCP26_VALUE_MME_GLOBAL": "Maize Area(#10^2# ha)",
  "EXP_GDP_2030S_SSP1_VALUE_SING_GLOBAL": "GDP(#10^6# US$)",
  "EXP_POP_RAIN_2030S_RCP26_VALUE_MMS_GLOBAL": "SD _RAIN",
  "EXP_POP_RAIN_2030S_RCP85_VALUE_MMS_GLOBAL": "SD _RAIN",
  "EXP_POP_2030S_SSP2_VALUE_SING_GLOBAL": "Population(person)",
  "EXP_RICE_2050S_RCP85_VALUE_MME_GLOBAL": "Rice Area(#10^2# ha)",
  "EXP_POP_RAIN_2050S_RCP26_VALUE_MMS_GLOBAL": "SD _RAIN",
  "EXP_POP_RAIN_2000S_S0_VALUE_MME_GLOBAL": "Population exposure(106person-mm)",
  "EXP_POP_HT_2030S_RCP45_VALUE_MME_GLOBAL": "Population exposure(#10^6# person-day)",
  "EXP_RICE_2030S_RCP26_VALUE_MME_GLOBAL": "Rice Area(#10^2# ha)",
  "EXP_POP_RAIN_2050S_RCP85_CHANGE_MMS_GLOBAL": "SD_RAIN_CHANGE",
  "EXP_MAIZE_2030S_RCP85_VALUE_MME_GLOBAL": "Maize Area(#10^2# ha)",
  "EXP_GDP_2050S_SSP1_VALUE_SING_GLOBAL": "GDP(#10^6# US$)",
  "EXP_WHEAT_2030S_RCP85_VALUE_MME_GLOBAL": "Wheat Cultivation Area(#10^2# ha)",
  "EXP_POP_RAIN_2050S_RCP45_CHANGE_MMS_GLOBAL": "SD _RAIN _CHANGE",
  "EXP_POP_2050S_SSP2_VALUE_SING_GLOBAL": "Population(person)",
  "EXP_RICE_2030S_RCP45_VALUE_MME_GLOBAL": "Rice Area(#10^2# ha)",
  "EXP_MAIZE_2050S_RCP85_VALUE_MME_GLOBAL": "Maize Area(#10^2# ha)",
  "EXP_ROAD_2010_S0_VALUE_SING_GLOBAL": "Road(km)",
  "EXP_WHEAT_2030S_RCP26_VALUE_MME_GLOBAL": "Wheat Cultivation Area(#10^2# ha)",
  "EXP_WHEAT_2050S_RCP85_VALUE_MME_GLOBAL": "Wheat Cultivation Area(#10^2# ha)",
  "EXP_GDP_2000S_S0_VALUE_SING_GLOBAL": "GDP(#10^6# US$)",
  "EXP_GDP_2030S_SSP2_VALUE_SING_GLOBAL": "GDP(#10^6# US$)",
  "EXP_POP_RAIN_2030S_RCP45_VALUE_MMS_GLOBAL": "SD _RAIN",
  "EXP_RICE_HT_2030S_RCP45_VALUE_MME_GLOBAL": "Area Exposure(#10^2# ha)",
  "EXP_IND_VALUE_2050S_SSP3_VALUE_SING_GLOBAL": "Industrial value added(#10^6# USD)",
  "EXP_MAIZE_HT_2050S_RCP45_VALUE_MME_GLOBAL": "Area Exposure(#10^2# ha)",
  "EXP_WHEAT_2000S_S0_VALUE_MME_GLOBAL": "Wheat Cultivation Area(#10^2# ha)",
  "EXP_ROAD_2050S_SSP1_VALUE_SING_GLOBAL": "Road(km)",
  "EXP_POP_RAIN_2030S_RCP26_VALUE_MME_GLOBAL": "Population exposure(106person-mm)",
  "EXP_RICE_2050S_RCP45_VALUE_MME_GLOBAL": "Rice Area(#10^2# ha)",
  "EXP_POP_RAIN_2050S_RCP26_VALUE_MME_GLOBAL": "Population exposure(106person-mm)",
  "EXP_POP_RAIN_2000S_S0_VALUE_MMS_GLOBAL": "SD_RAIN",
  "EXP_RICE_2000S_S0_VALUE_MME_GLOBAL": "Rice Area(#10^2# ha)",
  "EXP_POP_RAIN_2050S_RCP85_CHANGE_MME_GLOBAL": "POP_RAIN_CHANGE (106person-mm)",
  "EXP_POP_2050S_SSP3_VALUE_SING_GLOBAL": "Population(person)",
  "EXP_POP_HT_2050S_RCP85_VALUE_MME_GLOBAL": "Population exposure(#10^6# person-day)",
  "EXP_ROAD_2030S_SSP2_VALUE_SING_GLOBAL": "Road(km)",
  "EXP_MAIZE_HT_2030S_RCP45_VALUE_MME_GLOBAL": "Area Exposure(#10^2# ha)",
  "EXP_POP_RAIN_2050S_RCP45_VALUE_MMS_GLOBAL": "SD _RAIN",
  "EXP_POP_HT_2000S_S0_VALUE_MME_GLOBAL": "Population exposure(#10^6# person-day)",
  "EXP_MAIZE_2050S_RCP26_VALUE_MME_GLOBAL": "Maize Area(#10^2# ha)",
  "EXP_IND_VALUE_2000S_S0_VALUE_SING_GLOBAL": "Industrial value added(#10^6# USD)",
  "EXP_RICE_HT_2050S_RCP85_VALUE_MME_GLOBAL": "Area Exposure(#10^2# ha)",
  "EXP_ROAD_2030S_SSP1_VALUE_SING_GLOBAL": "Road(km)",
  "GDP_EXPOSURE_DROUGHT_HIS_2000S_EXTREME": "GDP exposure(#10^6# US$)",
  "GDP_EXPOSURE_DROUGHT_HIS_2000S_NORMAL":"GDP exposure(#10^6# US$)"
}



// WEBPACK FOOTER //
// ./src/view/BSD/BSDConfigLegendTitle_Population.js